/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTallymark4 = createReactComponent("tallymark-4", "IconTallymark4", [
  ["path", { d: "M6 5l0 14", key: "svg-0" }],
  ["path", { d: "M10 5l0 14", key: "svg-1" }],
  ["path", { d: "M14 5l0 14", key: "svg-2" }],
  ["path", { d: "M18 5l0 14", key: "svg-3" }]
]);

export { IconTallymark4 as default };
//# sourceMappingURL=IconTallymark4.js.map
